import React from 'react';
import PropTypes from 'prop-types';
import { mapProps } from 'recompose';
import { Text } from 'components/core/Typography';
import { Checkmark, CrossedCircle } from 'components/svg';

export const enhance = mapProps(({ amenity: { hasAttribute, label, showAlways } }) => ({
	label,
	hasAttribute,
	display: hasAttribute || showAlways
}));

export function Amenity({ label, hasAttribute, display }) {
	return (display ? (
		<div className="amenity">
			{hasAttribute ? <Checkmark /> : <CrossedCircle />}
			<Text>{label}</Text>
		</div>
	) : null);
}

Amenity.propTypes = {
	label: PropTypes.string,
	hasAttribute: PropTypes.bool,
	display: PropTypes.bool
};

export default enhance(Amenity);
